var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import 'isomorphic-fetch';
import BaseApi from '~/api/base';
import ApiError from '~/errors/api';
import mockFiles from './mock';
class FileTransfer extends BaseApi {
    constructor() {
        super();
        this.useMock = window.location.search.includes('MOCK_E2E');
    }
    get(fileTransferUrl) {
        return this.useMock
            ? mockFiles[fileTransferUrl]
            : this.getFile(fileTransferUrl);
    }
    getFile(fileTransferUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const redirectToErrorPage = true;
            let response;
            try {
                response = yield fetch(fileTransferUrl, {
                    method: 'GET',
                    mode: 'cors',
                    headers: {
                        Accept: 'application/json',
                    },
                    credentials: 'include',
                });
            }
            catch (error) {
                if (redirectToErrorPage) {
                    const apiError = new ApiError(`Failed to GET file using url ${fileTransferUrl}: ${error.message}`);
                    const info = JSON.stringify({ fileTransferUrl });
                    window.routeToErrorPage(apiError, info);
                }
            }
            if (response && response.status === 200) {
                const res = yield response.blob();
                return res;
            }
        });
    }
}
const FileTransferApi = new FileTransfer();
export default FileTransferApi;
